// import { TOGGLE_THEME, SET_LIGHT_THEME, SET_DARK_THEME } from '../actions/themeActions';

// const initialState = {
//     mode: 'light', // Default theme mode
//   };
  
//   const themeReducer = (state = initialState, action) => {
//     switch (action.type) {
//       case TOGGLE_THEME:
//         return {
//           ...state,
//           mode: state.mode === 'light' ? 'dark' : 'light',
//         };
//       case SET_LIGHT_THEME:
//         return {
//           ...state,
//           mode: 'light',
//         };
//       case SET_DARK_THEME:
//         return {
//           ...state,
//           mode: 'dark',
//         };
//       default:
//         return state;
//     }
//   };
  
//   export default themeReducer;

import { SET_THEME } from "../types";
import val from "../../getThemeDetails"
const initialState = {
  theme: val.theme 
  // localStorage.getItem('theme') || 'default', // Get the initial theme from localStorage or default
};

const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_THEME:
      localStorage.setItem('theme', action.payload); // Set theme in localStorage
      return {
        ...state,
        theme: action.payload, // Update Redux state
      };
    default:
      return state;
  }
};

export default themeReducer;
